import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import Modal, { ModalHeader, ModalTitle, ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { Stack } from '@atlaskit/primitives';

type ModalSkeletonProps = {
	title?: string;
	onClose?: () => void;
};

export const ModalSkeleton = ({ onClose, title }: ModalSkeletonProps) => (
	<Modal onClose={onClose} width={968} height={576}>
		<ModalHeader>
			{title ? (
				<ModalTitle>{title}</ModalTitle>
			) : (
				<Stack grow="fill">
					<SkeletonItem />
				</Stack>
			)}
		</ModalHeader>
		<ModalBody>
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
		</ModalBody>
		<ModalFooter />
	</Modal>
);
